module.exports = __webpack_public_path__ + "static/img/Dayne_Zorko_mobile.f27fc79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dayne_Zorko_mobile.jpg
// module id = j1yV
// module chunks = 0